(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-variants"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('product-variants')) {
    customElements.define(
      'product-variants',
      class ProductVariants extends HTMLElement {
        connectedCallback() {
          if (this._init) return;
          this._init = true;

          const mapEl = this.querySelector('.pv-variant-map');
          try {
            this.variantMap = JSON.parse(mapEl.textContent);
          } catch (e) {
            this.variantMap = {};
          }

          this.fieldsets = Array.from(this.querySelectorAll('.variant-option'));
          this.positions = this.fieldsets.map((f) => f.dataset.optionPosition);

          // Detect touch so hover-to-activate degrades to tap on mobile.
          this.isTouch = window.matchMedia('(hover: none)').matches;

          // activeColour = the currently hovered/tapped swatch value, or null.
          this.activeColour = null;
          this.colourPosition = null;

          this.swatchLabels = Array.from(
            this.querySelectorAll('.variant-option--swatches .variant-option__label')
          );

          this.swatchLabels.forEach((label) => {
            if (this.isTouch) {
              label.addEventListener('click', (e) => {
                e.preventDefault();
                this.toggleColour(label);
              });
            } else {
              label.addEventListener('pointerenter', () => this.setColour(label));
              label.addEventListener('pointerleave', () => this.clearColour(label));
              // Keyboard parity.
              label.setAttribute('tabindex', '0');
              label.addEventListener('focus', () => this.setColour(label));
              label.addEventListener('blur', () => this.clearColour(label));
            }
          });

          // On load: no colour active, sizes reflect availability across all colours.
          this.refreshSizeAvailability();
        }

        setColour(label) {
          this.activeColour = label.dataset.optionValue;
          this.colourPosition = label.dataset.optionPosition;
          this.paintActiveSwatch();
          this.updateSelectedValueText();
          this.refreshSizeAvailability();
        }

        clearColour(label) {
          if (this.activeColour !== label.dataset.optionValue) return;
          this.activeColour = null;
          this.colourPosition = null;
          this.paintActiveSwatch();
          this.updateSelectedValueText();
          this.refreshSizeAvailability();
        }

        toggleColour(label) {
          if (this.activeColour === label.dataset.optionValue) {
            this.activeColour = null;
            this.colourPosition = null;
          } else {
            this.activeColour = label.dataset.optionValue;
            this.colourPosition = label.dataset.optionPosition;
          }
          this.paintActiveSwatch();
          this.updateSelectedValueText();
          this.refreshSizeAvailability();
        }

        paintActiveSwatch() {
          this.swatchLabels.forEach((label) => {
            label.dataset.pvActive =
              label.dataset.optionValue === this.activeColour ? 'true' : 'false';
          });
        }

        // Mirror the native picker's legend value text.
        updateSelectedValueText() {
          this.fieldsets.forEach((fs) => {
            if (fs.dataset.isSwatch !== 'true') return;
            const span = fs.querySelector('[data-pv-selected-value]');
            if (span) span.textContent = this.activeColour || '';
          });
        }

        // Dim size pills not in stock for the active colour (or, if no colour
        // active, those not in stock in ANY colour).
        refreshSizeAvailability() {
          const sizeLabels = this.querySelectorAll(
            '.variant-option:not(.variant-option--swatches) .variant-option__label'
          );

          sizeLabels.forEach((label) => {
            const pos = label.dataset.optionPosition;
            const val = label.dataset.optionValue;

            const candidate = {};
            this.positions.forEach((p) => {
              if (p === pos) {
                candidate[p] = val;
              } else if (p === this.colourPosition) {
                candidate[p] = this.activeColour; // may be null = wildcard
              } else {
                candidate[p] = null; // wildcard
              }
            });

            label.dataset.pvAvailable = this.matchExists(candidate) ? 'true' : 'false';
          });
        }

        matchExists(candidate) {
          return Object.keys(this.variantMap).some((key) => {
            if (this.variantMap[key] !== 1) return false;
            const parts = key.split('|');
            return this.positions.every((p, idx) => {
              const want = candidate[p];
              if (want == null) return true;
              return parts[idx] === want;
            });
          });
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
